import styled from 'styled-components';

const DISABLED_OPACITY = 0.5;

type StyledRootProps = { $disabled: boolean };

export const StyledDebugRoot = styled.details<StyledRootProps>`
   background-color: ${(props) => props.theme.white};
   border-radius: 6px;
   padding: 8px 12px;
   font-size: 11px;
   color: ${(props) => props.theme.textBody};
   opacity: ${(props) => (props.$disabled ? DISABLED_OPACITY : 1)};
   pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};
`;
StyledDebugRoot.displayName = 'StyledDebugRoot';

export const StyledDebugSummary = styled.summary`
   cursor: pointer;
   font-weight: 600;
   user-select: none;
   color: ${(props) => props.theme.textBody};
   text-transform: uppercase;
   letter-spacing: 0.04em;
`;
StyledDebugSummary.displayName = 'StyledDebugSummary';

export const StyledDebugGrid = styled.div`
   display: grid;
   grid-template-columns: 100px 100px;
   gap: 6px 16px;
   margin-top: 10px;
`;
StyledDebugGrid.displayName = 'StyledDebugGrid';

export const StyledDebugRow = styled.div`
   display: flex;
   flex-direction: column;
   gap: 2px;
`;
StyledDebugRow.displayName = 'StyledDebugRow';

export const StyledDebugLabel = styled.label`
   font-weight: 600;
   color: ${(props) => props.theme.textBody};
   white-space: nowrap;
`;
StyledDebugLabel.displayName = 'StyledDebugLabel';

export const StyledDebugSelect = styled.select`
   font-size: 11px;
   padding: 2px 4px;
   border: 1px solid ${(props) => props.theme.border};
   border-radius: 3px;
`;
StyledDebugSelect.displayName = 'StyledDebugSelect';

export const StyledDebugSectionTitle = styled.div`
   grid-column: 1 / -1;
   font-weight: 700;
   color: ${(props) => props.theme.textBody};
   text-transform: uppercase;
   letter-spacing: 0.05em;
   margin-top: 6px;
   padding-top: 4px;
   border-top: 1px solid #eee;
`;
StyledDebugSectionTitle.displayName = 'StyledDebugSectionTitle';

export const StyledDebugInput = styled.input`
   font-size: 11px;
   padding: 2px 4px;
   border: 1px solid ${(props) => props.theme.border};
   border-radius: 3px;
   width: 100%;
   box-sizing: border-box;
`;
StyledDebugInput.displayName = 'StyledDebugInput';
